exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-sitemap-tsx": () => import("./../../../src/pages/sitemap.tsx" /* webpackChunkName: "component---src-pages-sitemap-tsx" */),
  "component---src-templates-blogs-listing-template-tsx": () => import("./../../../src/templates/blogsListingTemplate.tsx" /* webpackChunkName: "component---src-templates-blogs-listing-template-tsx" */),
  "component---src-templates-master-template-tsx": () => import("./../../../src/templates/masterTemplate.tsx" /* webpackChunkName: "component---src-templates-master-template-tsx" */)
}

